module.exports = __webpack_public_path__ + "static/img/sf1226.e9349b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/sf1226.png
// module id = w69W
// module chunks = 0